<template>
  <b-card-code title="Tartály feltöltés">
    <b-alert
      show
      variant="info"
      class="mb-2"
    >
      A dátum/idő automatikus. A feltöltés a bejelentkezett felhasználó nevében kerül mentésre.
    </b-alert>

    <b-form @submit.prevent="submitForm">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Cég neve *">
            <b-form-select
              v-model="form.company"
              :options="companyOptions"
              value-field="value"
              text-field="text"
              :disabled="isSaving || !canSave"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Liter mennyiség *">
            <b-form-input
              v-model="form.liter"
              type="number"
              step="0.01"
              min="0.01"
              placeholder="pl. 350.50"
              :disabled="isSaving || !canSave"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <small class="text-muted d-block mb-2">
            Dátum/idő: automatikus (mentéskor kerül rögzítésre).
          </small>
        </b-col>
      </b-row>

      <b-alert
        v-if="!canSave"
        show
        variant="warning"
        class="mb-2"
      >
        Nincs jogosultságod tartály feltöltés mentéséhez.
      </b-alert>

      <b-button
        v-if="canSave"
        variant="primary"
        type="submit"
        block
        :disabled="isSaving"
      >
        {{ isSaving ? 'Mentés folyamatban...' : 'Mentés' }}
      </b-button>
    </b-form>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import { checkRole } from '@/middleware/authLoader'
import {
  BAlert,
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
} from 'bootstrap-vue'

export default {
  name: 'TankolasRefill',
  components: {
    BCardCode,
    BAlert,
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
  },
  data() {
    return {
      isSaving: false,
      form: {
        company: null,
        liter: null,
      },
      companyOptions: [
        { value: null, text: 'Válassz céget' },
        { value: 'Monolit-Profi Kft', text: 'Monolit-Profi Kft' },
        { value: 'Monolit-Épszer Kft', text: 'Monolit-Épszer Kft' },
      ],
    }
  },
  computed: {
    canSave() {
      return checkRole('tankolas_role_tankolo')
        || checkRole('tankolas_role_halado')
        || checkRole('tankolas_role_admin')
    },
  },
  methods: {
    authHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }
    },
    toastError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message || 'Mentés sikertelen.',
          icon: 'XOctagonIcon',
          variant: 'danger',
        },
      })
    },
    toastSuccess(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message || 'Mentve.',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },
    validateForm() {
      if (!this.form.company) return 'Add meg a céget.'
      if (this.form.liter === null || this.form.liter === '') return 'Add meg a liter mennyiséget.'
      if (Number(this.form.liter) <= 0) return 'A liter mennyiség legyen nagyobb mint 0.'
      return null
    },
    extractBackendError(error) {
      if (!error || !error.response || !error.response.data) return 'Mentés sikertelen.'
      const data = error.response.data
      if (data.message) return data.message
      if (data.errors && typeof data.errors === 'object') {
        const firstField = Object.keys(data.errors)[0]
        if (firstField && Array.isArray(data.errors[firstField]) && data.errors[firstField][0]) {
          return data.errors[firstField][0]
        }
      }
      return 'Mentés sikertelen.'
    },
    async submitForm() {
      if (!this.canSave) {
        this.toastError('Nincs jogosultságod ehhez a művelethez.')
        return
      }

      const validationError = this.validateForm()
      if (validationError) {
        this.toastError(validationError)
        return
      }

      this.isSaving = true
      try {
        const response = await axios({
          method: 'post',
          url: 'tankolas/refill',
          headers: this.authHeaders(),
          data: {
            company: this.form.company,
            liter: this.form.liter,
          },
        })

        this.toastSuccess(response.data.message || 'Mentve.')
        this.form.liter = null
      } catch (error) {
        this.toastError(this.extractBackendError(error))
      } finally {
        this.isSaving = false
      }
    },
  },
}
</script>
